/**
 * EVT Restaurant Builder Theme JavaScript
 *
 * @package EVT Restaurant Builder
 * @since 1.0.0
 */

// Import pattern-specific modules
import { initMenuCategoryFilter } from './patterns/menu-list-with-images.js';
import { initImageMosaic } from './patterns/image-mosaic.js';
import { initHeroLogoController } from './patterns/hero.js';
import { initWhatsOnSlider } from './patterns/whats-on-slider.js';
import { initThreeColumnSlider } from './patterns/three-column-slider.js';
import { initGallerySliderRoll } from './patterns/gallery-slider-roll.js';
import { initCarouselText } from './patterns/carousel-text.js';
import { initMarqueeText } from './patterns/marquee-text.js';

// Import utility functions
import { initSmoothScrolling } from './utils/smooth-scrolling.js';
import { initResponsiveFeatures } from './utils/responsive-features.js';
import { initMobileMenu } from './utils/mobile-menu.js';
import { initDataBgImagesObserver } from './utils/data-bg-images.js';
import { initReservationTrigger } from './utils/reservation-trigger.js';
import { initFixedHeader } from './utils/fixed-header.js';
import initFormInputState from './utils/form-input-state.js';
import { initGtmEvents } from './utils/gtm-events.js';
import { initFullWidthFOffset } from './utils/full-width-offset.js';

// Import map initialization
import { initGoogleMap } from './map.js';

// Expose initGoogleMap to global scope for Google Maps callback
window.initGoogleMap = initGoogleMap;

// Theme initialization
document.addEventListener('DOMContentLoaded', function() {
    console.log('EVT Restaurant Builder JS loaded');

    // Initialize theme features
    initSmoothScrolling();
    initResponsiveFeatures();
    initFixedHeader();
    initImageMosaic();
    initMenuCategoryFilter();
    initMobileMenu();
    initHeroLogoController();
    initDataBgImagesObserver();
    initWhatsOnSlider();
    initThreeColumnSlider();
    initGallerySliderRoll();
    initCarouselText();
    initMarqueeText();
    initReservationTrigger();
    initFormInputState();
    initGtmEvents();
    initFullWidthFOffset();
});


